var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grupo-parametros"},_vm._l((_vm.parametrosDeBusca),function(param,index){return _c('div',{key:`${param.key}-${index}`},[_c('BotaoParametroBusca',{attrs:{"label":param.label,"valor":param.valor,"onClick":(event) => _vm.onClick(event, param)}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }